<nz-layout *transloco="let t" class="layout bg-[#fbfbfb]">
  <nz-header class="p-0">
    <div class="container flex justify-between">
      <div class="flex gap-4 lg:gap-0 min-w-0 overflow-hidden flex-1">
        <!--          Small Screen Navbar-->
        <div *ngIf="!this.isSubUrl" class="lg:hidden flex">
          <nz-button-group>
            <button
              nz-button
              nz-dropdown
              [nzDropdownMenu]="menu1"
              nzPlacement="bottomLeft">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"/>
              </svg>
            </button>
          </nz-button-group>
          <nz-dropdown-menu #menu1="nzDropdownMenu">
            <ul
              nz-menu
              nzTheme="light"
              nzMode="inline"
              class="border-2 border-primary rounded-xl">
              <li
                *appHasAnyPrivilege="'DASHBOARD.VIEW'"
                nz-menu-item
                [routerLinkActive]="'ant-menu-item-selected'">
                <a routerLink="/admin/dashboard">{{ t('nav.dashboard') }}</a>
              </li>
              <li
                *appHasAnyPrivilege="'ITINERARY.VIEW'"
                nz-menu-item
                [routerLinkActive]="'ant-menu-item-selected'">
                <a routerLink="/admin/itineraries">{{ t('nav.itineraries') }}</a>
              </li>
              <li
                *appHasAnyPrivilege="'CUSTOMER.VIEW'"
                nz-menu-item
                [routerLinkActive]="'ant-menu-item-selected'">
                <a routerLink="/admin/customers">{{ t('nav.customers') }}</a>
              </li>
              <li
                *appHasAnyPrivilege="'AGENT.VIEW'"
                nz-menu-item
                [routerLinkActive]="'ant-menu-item-selected'">
                <a routerLink="/admin/agents">{{ t('nav.agents') }}</a>
              </li>
              <li
                *appHasAnyPrivilege="
                  'DESTINATION.VIEW,EXPERIENCE.VIEW,OTHER.CONTENT.VIEW'
                "
                nz-submenu
                [nzTitle]="subTitle">
                <ng-template #subTitle
                ><span>{{ t('nav.content') }}</span></ng-template
                >
                <ul>
                  <li
                    *appHasAnyPrivilege="'DESTINATION.VIEW'"
                    nz-menu-item
                    [routerLinkActive]="'ant-menu-item-selected'">
                    <a routerLink="/admin/content/destinations">{{ t('nav.destinations') }}</a>
                  </li>
                  <li
                    *appHasAnyPrivilege="'EXPERIENCE.VIEW'"
                    nz-menu-item
                    [routerLinkActive]="'ant-menu-item-selected'">
                    <a routerLink="/admin/content/experiences">{{ t('nav.experiences') }}</a>
                  </li>
                  <li
                    *appHasAnyPrivilege="'OTHER.CONTENT.VIEW'"
                    nz-menu-item
                    [routerLinkActive]="'ant-menu-item-selected'">
                    <a routerLink="/admin/content/other">{{ t('nav.other') }}</a>
                  </li>
                  <li
                    nz-menu-item
                    [routerLinkActive]="'ant-menu-item-selected'">
                    <a routerLink="/admin/content/preview-option">{{ t('nav.previewOptions') }}</a>
                  </li>
                </ul>
              </li>
              <li
                *appHasAnyPrivilege="'RATES.VIEW'"
                nz-submenu
                [nzTitle]="ratesSubTitle">
                <ng-template #ratesSubTitle
                ><span>{{ t('nav.rates') }}</span></ng-template
                >
                <ul>
                  <li
                    *appHasAnyPrivilege="'RATES.ACCOMMODATION.VIEW'"
                    nz-menu-item
                    [routerLinkActive]="'ant-menu-item-selected'">
                    <a routerLink="/admin/rates">{{ t('nav.accommodation') }}</a>
                  </li>
                  <li
                    *appHasAnyPrivilege="'RATES.TRANSPORT.VIEW'"
                    nz-menu-item
                    [routerLinkActive]="'ant-menu-item-selected'">
                    <a routerLink="/admin/rates/transport-config">{{ t('nav.transport') }}</a>
                  </li>
                </ul>
              </li>
              <li
                *appHasAnyPrivilege="'USER.VIEW'"
                nz-menu-item
                [routerLinkActive]="'ant-menu-item-selected'">
                <a routerLink="/admin/users">{{ t('nav.users') }}</a>
              </li>
              <li
                *appHasAnyPrivilege="
                  'SETTING.VIEW'
                "
                nz-menu-item
                [routerLinkActive]="'ant-menu-item-selected'">
                <a
                  [routerLink]="['/admin/settings']"
                  [queryParams]="{tab: SETTINGS.SETTINGS_TAB_KEYS.ACCOUNT}">
                  {{ t('nav.settings') }}
                </a>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>

        <!--                logo section-->
        <div class="brand">
          <img
            class="w-full h-full object-contain px-2"
            style="border-radius: 18px;"
            src="{{organizationSetting?.logo ? organizationSetting?.logo : 'assets/img/logo.png'}}"
            alt="Company Logo"/>
        </div>

        <!--        Large Screen Navbar-->
        <div *ngIf="!this.isSubUrl" class="hidden lg:block nav-scroll-wrapper">
          <ul nz-menu nzTheme="light" nzMode="horizontal" class="border-0">
            <li
              *appHasAnyPrivilege="'DASHBOARD.VIEW'"
              nz-menu-item
              [routerLinkActive]="'ant-menu-item-selected'">
              <a routerLink="/admin/dashboard">{{ t('nav.dashboard') }}</a>
            </li>
            <li
              *appHasAnyPrivilege="'ITINERARY.VIEW'"
              nz-menu-item
              [routerLinkActive]="'ant-menu-item-selected'">
              <a routerLink="/admin/itineraries">{{ t('nav.itineraries') }}</a>
            </li>
            <li
              *appHasAnyPrivilege="'CUSTOMER.VIEW'"
              nz-menu-item
              [routerLinkActive]="'ant-menu-item-selected'">
              <a routerLink="/admin/customers">{{ t('nav.customers') }}</a>
            </li>
            <li
              *appHasAnyPrivilege="'AGENT.VIEW'"
              nz-menu-item
              [routerLinkActive]="'ant-menu-item-selected'">
              <a routerLink="/admin/agents">{{ t('nav.agents') }}</a>
            </li>
            <li
              *appHasAnyPrivilege="
                  'DESTINATION.VIEW,EXPERIENCE.VIEW,OTHER.CONTENT.VIEW'
                "
              nz-submenu
              [nzTitle]="subTitle">
              <ng-template #subTitle
              ><span>{{ t('nav.content') }}</span></ng-template
              >
              <ul>
                <li
                  *appHasAnyPrivilege="'DESTINATION.VIEW'"
                  nz-menu-item
                  [routerLinkActive]="'ant-menu-item-selected'">
                  <a routerLink="/admin/content/destinations">{{ t('nav.destinations') }}</a>
                </li>
                <li
                  *appHasAnyPrivilege="'EXPERIENCE.VIEW'"
                  nz-menu-item
                  [routerLinkActive]="'ant-menu-item-selected'">
                  <a routerLink="/admin/content/experiences">{{ t('nav.experiences') }}</a>
                </li>
                <li
                  *appHasAnyPrivilege="'OTHER.CONTENT.VIEW'"
                  nz-menu-item
                  [routerLinkActive]="'ant-menu-item-selected'">
                  <a routerLink="/admin/content/other">{{ t('nav.other') }}</a>
                </li>
              </ul>
            </li>
            <li
              *appHasAnyPrivilege="'RATES.VIEW'"
              nz-submenu
              [nzTitle]="ratesSubTitle2">
              <ng-template #ratesSubTitle2
              ><span>{{ t('nav.rates') }}</span></ng-template
              >
              <ul>
                <li
                  *appHasAnyPrivilege="'RATES.ACCOMMODATION.VIEW'"
                  nz-menu-item
                  [routerLinkActive]="'ant-menu-item-selected'">
                  <a routerLink="/admin/rates">{{ t('nav.accommodation') }}</a>
                </li>
                <li
                  *appHasAnyPrivilege="'RATES.TRANSPORT.VIEW'"
                  nz-menu-item
                  [routerLinkActive]="'ant-menu-item-selected'">
                  <a routerLink="/admin/rates/transport-config">{{ t('nav.transport') }}</a>
                </li>
              </ul>
            </li>
            <li
              *appHasAnyPrivilege="'USER.VIEW'"
              nz-menu-item
              [routerLinkActive]="'ant-menu-item-selected'">
              <a routerLink="/admin/users">{{ t('nav.users') }}</a>
            </li>
            <li
              *appHasAnyPrivilege="
                  'SETTING.VIEW'
              "
              nz-menu-item
              [routerLinkActive]="'ant-menu-item-selected'">
              <a
                [routerLink]="['/admin/settings']"
                [queryParams]="{tab: SETTINGS.SETTINGS_TAB_KEYS.ACCOUNT}">
                {{ t('nav.settings') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="user mt-[17px]">
        <div class="flex flex-row">
          <div class="flex flex-row items-center gap-2 mr-5 mt-1" *ngIf="statusObj.status === 'in_trial'">
            <div class="status-pill" [ngClass]="getPillClass(statusObj.status)">
                {{ statusObj.text }}
                <i *appHasAnyPrivilege="'SETTING.BILLING'"
                  nz-icon
                  nzType="info-circle"
                  nzTheme="outline"
                  nz-tooltip
                  [nzTooltipTitle]="t('chargebee.subscription.trialTooltip')"
                  class="pill-icon hover:cursor-pointer"
                  (click)="goToBilling()"
                ></i>
            </div>
            <button
              *ngIf="statusObj.plan === 'month'"
              nz-button
              nzType="primary"
              nzSize="small"
              class="!rounded-full !text-xs !font-semibold !inline-flex !items-center !justify-center"
              (click)="openUpgradeModal()">
              {{ t('chargebee.subscription.upgrade') }}
            </button>
          </div>
          <div class="flex flex-col justify-center text-end">
            <p class="mr-3 text-base hidden sm:block">
              {{ user[0]?.firstname }} {{ user[0]?.lastname }}
            </p>
            <p class="mr-3 text-sm hidden sm:block">{{ user[0]?.role?.name }}</p>
          </div>
          <div class="justify-center">
            <img
              class="w-10 h-10 rounded-full bg-base-200 p-1 cursor-pointer object-cover"
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="userMenu"
              [nzPlacement]="'bottomRight'"
              src="{{user[0]?.profilePic ? user[0]?.profilePic : 'assets/img/profile_avatar.jpg'}}"
              alt=""/>
          </div>
          <nz-dropdown-menu #userMenu="nzDropdownMenu">
            <ul nz-menu>
              <li
                *appHasAnyPrivilege="'SETTING.VIEW'"
                nz-menu-item>
                <a
                  [routerLink]="['/admin/settings']"
                  [queryParams]="{tab: SETTINGS.SETTINGS_TAB_KEYS.ACCOUNT}">
                  {{ t('user.accountSettings') }}
                </a>
              </li>
              <li class="flex items-center" nz-submenu [nzTitle]="langPrefTitle">
                <ng-template #langPrefTitle>
                  <span>{{ t('user.languagePreference') }}</span>
                </ng-template>
                <ul>
                  <li
                    *ngFor="let lang of availableLanguages"
                    nz-menu-item
                    [nzSelected]="activeLang === lang.code"
                    (click)="changeLanguage(lang.code)">
                    {{ t(lang.labelKey) }}
                  </li>
                </ul>
              </li>
              <li nz-menu-item nzDanger (click)="logout()">{{ t('user.logout') }}</li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
    </div>
  </nz-header>
  <nz-content class="container">
    <div>
      <router-outlet></router-outlet>
    </div>
  </nz-content>
  <nz-footer>
    <div class="flex flex-col gap-y-3">
      <div>
        ©️ {{this.year}} {{ t('footer.copyright') }} | {{ t('footer.version') }} {{ this.version }}
      </div>
      <div class="flex justify-center">
       <img src="assets/img/logo_purple.png" class="object-cover h-8" alt="Purple Logo">
      </div>
    </div>
  </nz-footer>
</nz-layout>
